<div class="flow-canvas">

    <app-zs-flow-action-node *ngFor="let node of data.nodes" [nodedata]="node" [attr.id]="node.id"></app-zs-flow-action-node>

</div>
<!-- <span *ngFor="let node of edges">
  <zs-node-connector class="zs-node-connector" from="#{{node.source}}" to="#{{node.target}}" within=".flow-canvas"></zs-node-connector>
</span> -->